import { render, staticRenderFns } from "./BalanceHistoryTableComment.vue?vue&type=template&id=3e40a87f&scoped=true"
import script from "./BalanceHistoryTableComment.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryTableComment.vue?vue&type=script&lang=js"
import style0 from "./BalanceHistoryTableComment.vue?vue&type=style&index=0&id=3e40a87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40a87f",
  null
  
)

export default component.exports